<era-device-action-bar-ui [allowAssign]="allowAssign"
                          [allowSpare]="allowSpare"
                          [allowUnassign]="allowUnassign"
                          [allowUnavailable]="allowUnavailable"
                          [allowHousekeeping]="allowHousekeeping"
                          [allowStaff]="allowStaff"
                          [allowFrontDesk]="allowFrontDesk"
                          [allowBar]="allowBar"
                          [allowKiosk]="allowKiosk"
                          [device]="device()"
                          [notesEnabled]="notesEnabled"
                          [assignmentHistoryEnabled]="assignmentHistoryEnabled"
                          (openNotesModalEvent)="openNotesModal()"
                          (openAssignmentHistoryModalEvent)="openAssignmentHistoryModal()">
</era-device-action-bar-ui>